import { render, staticRenderFns } from "./assistant-com.vue?vue&type=template&id=4bb99c9c&scoped=true&"
import script from "./assistant-com.vue?vue&type=script&lang=js&"
export * from "./assistant-com.vue?vue&type=script&lang=js&"
import style0 from "./assistant-com.vue?vue&type=style&index=0&id=4bb99c9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb99c9c",
  null
  
)

export default component.exports